/**
 * Falkland Islands pound.
 */
export var FKP = {
  code: 'FKP',
  base: 10,
  exponent: 2
};